import res from "./res";

export default {
  res,
};
